import { IPaymentErrorMapEntry } from './payment-error.types';

export const PAYMENT_ERROR_FALLBACK_MESSAGE =
    "We couldn't process your payment. Please check your card details or contact Customer Services if you need further help.";

export const PAYMENT_TIMEOUT_DYNAMICS_ERROR_CODE = 'Front End Timeout for Checkout API';

export const PAYMENT_ERROR_ENTRIES: readonly IPaymentErrorMapEntry[] = [
    {
        customCode: 'CCR001',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_UnableToAuthorizePaymentCardTypeMissingOrNotSupported',
        userMessage:
            "We couldn't process your payment. Please check your card details or contact Customer Services if you need further help quoting CCR001."
    },
    {
        customCode: 'CCR002',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_UnableToAuthorizePayment',
        userMessage:
            "We couldn't authorise your payment. Please check your card details or contact Customer Services if you need further help quoting CCR002."
    },
    {
        customCode: 'CCR003',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_UnableToAuthorizePaymentCardAdditionalContextRequired',
        userMessage:
            "We couldn't authorise your payment. Please check your card details or contact Customer Services if you need further help quoting CCR003."
    },
    {
        customCode: 'CCR004',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_UnableToRetrieveCardPaymentAcceptResult',
        userMessage:
            "We couldn't authorise your payment. Please check your card details or contact Customer Services if you need further help quoting CCR004."
    },
    {
        customCode: 'CCR005',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_PaymentRequiresMerchantProperties',
        userMessage:
            "We couldn't process your payment. Please check your card details or contact Customer Services if you need further help quoting CCR005."
    },
    {
        customCode: 'CCR006',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_InvalidPaymentRequest',
        userMessage:
            "We couldn't process your payment. Please check your card details or contact Customer Services if you need further help quoting CCR006."
    },
    {
        customCode: 'CCR014',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_UnableToReadCardTokenInfo',
        userMessage:
            "We couldn't process your payment. Please check your card details or contact Customer Services if you need further help quoting CCR014."
    },
    {
        customCode: 'CCR023',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_PaymentAlreadyVoided',
        userMessage:
            "We couldn't process your payment. Please check your card details or contact Customer Services if you need further help quoting CCR023."
    },
    {
        customCode: 'CCR024',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_FraudRisk',
        userMessage:
            "We couldn't authorise your payment. Please check your card details or contact Customer Services if you need further help quoting CCR024."
    },
    {
        customCode: 'CCR025',
        dynamicsErrorCode: 'Front End Timeout for Checkout API',
        userMessage:
            "We're sorry, but there was an issue processing your order. Please contact Customer Services and we'll be happy to help quoting CCR025."
    },
    {
        customCode: 'CCR027',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_InvalidCartVersion',
        userMessage:
            "We couldn't process your payment. Please check your card details or contact Customer Services if you need further help quoting CCR027."
    },
    {
        customCode: 'CCR028',
        dynamicsErrorCode: 'Microsoft_Dynamics_Commerce_Runtime_MissingRequiredCartTenderLines',
        userMessage:
            "We couldn't process your payment. Please check your card details or contact Customer Services if you need further help quoting CCR028."
    }
];

export const PAYMENT_ERROR_MAP: ReadonlyMap<string, IPaymentErrorMapEntry> = new Map(
    PAYMENT_ERROR_ENTRIES.map(entry => [entry.dynamicsErrorCode, entry] as const)
);

export const PAYMENT_TIMEOUT_STATUSES: ReadonlySet<string> = new Set(['Timeout', 'Hook Timeout', 'Service Unavailable']);
